import { BaseApiService } from '@/shared/api/services/base.service';

/**
 * The Facade Kit SKU planted on the purchase intent. Stays the canonical
 * `ai.getfacade.*` identifier (shared with the Apple/Google catalog) — the
 * server resolves the actual pack from the Paddle transaction's price_id, so
 * this is just the correlation row's product label and must satisfy the
 * intent endpoint's `ai.getfacade.` shape rule.
 */
export const FACADE_KIT_SKU = 'ai.getfacade.pack.facade';

export interface PurchaseIntent {
  correlation_token: string;
  kind: string;
  product_id: string;
  project_id: string | null;
  status: string;
  expires_at: string;
}

/**
 * Purchase correlation (web). Mints a `purchase_intents` row BEFORE opening the
 * Paddle checkout; the returned `correlation_token` is planted in Paddle's
 * customData so the webhook recovers buyer + building deterministically.
 * Mirrors the Apple `appAccountToken` / Google `obfuscatedProfileId` flow.
 */
class PurchaseService extends BaseApiService {
  async createPackIntent(projectId: string): Promise<PurchaseIntent> {
    const body = this.formatJsonApiData('purchase-intent', {
      kind: 'pack',
      product_id: FACADE_KIT_SKU,
      provider: 'paddle',
      project_id: projectId,
    });

    const response = await this.post<{
      data: { attributes: PurchaseIntent };
    }>('/v1/purchases/intents', body);

    return response.data.attributes;
  }
}

export const purchaseService = new PurchaseService();
